import { Image, StyleSheet } from 'react-native'
import { useRouter } from 'expo-router'
import { DS } from '../../../design-system'
import Calendar from '../Calendar/Calendar'
import { fontFamily } from '../../../theme'
import { PlayerAvatar } from '../PlayerAvatar'
import React from 'react'
import { TeachingTableGameModelType } from '../../../models/api-store'
import { debounce } from 'lodash'
import { events } from '../../../models/analytics/analytics-events'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../models'
import { formatGameScheduledAt } from '../../../utils'

interface ItemProps {
  item: TeachingTableGameModelType
}

const ItemSchedule: React.FC<ItemProps> = observer(({ item }: ItemProps) => {
  const router = useRouter()
  const {
    game: { joinLiveGame, setPlayKind },
    session: { user },
    analytics: { setEvent }
  } = useStore()

  const userId = user?._id.toString() ?? ''
  const { teachingTable, scheduleTime, __typename } = item
  const teacherName = teachingTable?.teacherName ?? ''
  const formattedDate = formatGameScheduledAt(new Date(scheduleTime))

  const [month, day] = formattedDate.replace(',', '').split(' ')
  let typename = ''
  switch (__typename) {
    case 'TeachingTableGame':
      typename = 'Teaching Table'
  }

  const joinGame = async ({ channelName, teachingTable }: TeachingTableGameModelType) => {
    const isTableTeacher = teachingTable?.teacherId.toString() === userId.toString()
    const isObserver = teachingTable?.observers?.includes(userId.toString())

    if (channelName) {
      if (isTableTeacher || isObserver) {
        setPlayKind('observer')
      }
      setEvent(events.game.from_profile_screen, {
        channelName
      })

      await joinLiveGame(channelName)
      router.navigate('/game')
      return
    }
  }

  return (
    <DS.Frame>
      <DS.Frame gap={'8'} row justifyContent="space-between">
        <DS.Frame>
          <Calendar month={month.toUpperCase()} day={day} />
        </DS.Frame>
        <DS.Frame flex={1} gap="4">
          <DS.Text variant="Body Small/Regular" style={styles.type}>
            {typename}
          </DS.Text>
          <DS.Text variant="Body Medium/Medium" style={styles.name}>
            {teacherName}
          </DS.Text>
          <DS.Frame row gap="12">
            <DS.Text variant="Body Small/Regular" style={styles.date}>
              {formattedDate}
            </DS.Text>
          </DS.Frame>
        </DS.Frame>
        <DS.Frame>
          {teachingTable?.teacherAvatar ? (
            <Image
              style={styles.image}
              source={{ uri: teachingTable?.teacherAvatar }}
              alt={''}
              width={32}
              height={32}
            />
          ) : (
            <PlayerAvatar name={teacherName} size={4} />
          )}
        </DS.Frame>
      </DS.Frame>
      {item.status?.toLocaleLowerCase() === 'live' ? (
        <DS.Frame>
          <DS.Button
            style={{ marginTop: 12 }}
            variant="Medium/Primary"
            type="On Light"
            onPress={debounce(() => item.channelName && joinGame(item), 250)}
          >
            <DS.Text variant="Body Small/Medium" style={styles.btnJoin}>
              Join Game
            </DS.Text>
          </DS.Button>
        </DS.Frame>
      ) : null}
    </DS.Frame>
  )
})

export default ItemSchedule

const styles = StyleSheet.create({
  type: {
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 14
  },
  name: {
    fontWeight: '600',
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  date: {
    fontWeight: '400',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: 12
  },
  image: {
    backgroundColor: DS.palette['Global/White'],
    padding: 6,
    transform: [{ translateX: -8 }],
    borderWidth: 0.5,
    borderColor: 'gray',
    borderRadius: 20
  },
  btnJoin: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontSize: 14,
    color: DS.palette['Global/White']
  }
})
